<template>
  <div class="take-pic" :class="pos">
    <i :style="{width:size.w+'px',height:size.h+'px'}"></i>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Object,
      default: () => {
        return {
          w: 54,
          h: 54
        };
      }
    },
    pos: {
      type: String,
      default: "bottom"
    }
  },
  methods: {
    // collectFacility() {
    //   console.log('开始采集');
    //   this.$router.push({
    //     name:'collectAdd'
    //   })
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.take-pic {
  text-align: center;
  &.bottom {
    position: fixed;
    right: 16px;
    bottom: 64px;
  }
  &.center {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  i {
    z-index: 999;
    display: block;
    background-size: 100%;
    background-repeat: no-repeat;
    @include bg-image("~@/assets/imgs/采集");
  }
}
</style>





// WEBPACK FOOTER //
// src/components/TakePic.vue